import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function About({ stats }) {
  return (
    <div style={{ paddingTop: "30px" }}>
      {/* OUR VALUES / FEATURES BAND */}
      {/* <section className="py-5 bg-light">
        <div className="container my-5 py-4">
          <div className="row g-5 align-items-stretch">
            {/* Why Choose Us }
            <div className="col-md-6 d-flex flex-column justify-content-center p-4 shadow rounded-4 bg-white" data-aos="fade-right">
              <h3 className="fw-bold mb-4" style={{ color: '#6B46C1', fontFamily: "'Poppins',sans-serif" }}>Why Choose Us</h3>
              <ul className="list-unstyled">
                <li className="mb-3"><i className="bi bi-star-fill text-warning me-2"></i>Expert Guidance & Maximum Refunds</li>
                <li className="mb-3"><i className="bi bi-lightning-charge text-primary me-2"></i>Fast, Error-Free Filing</li>
                <li className="mb-3"><i className="bi bi-people-fill text-success me-2"></i>Trusted by Thousands Nationwide</li>
                <li><i className="bi bi-award text-pink me-2"></i>Industry-Leading Customer Service</li>
              </ul>
            </div>
            {/* What We Do }
            <div className="col-md-6 d-flex flex-column justify-content-center p-4 shadow rounded-4 bg-white" data-aos="fade-left">
              <h3 className="fw-bold mb-4" style={{ color: '#D53F8C', fontFamily: "'Poppins',sans-serif" }}>What We Do</h3>
              <ul className="list-unstyled">
                <li className="mb-3"><i className="bi bi-file-earmark-check text-primary me-2"></i>Personal & Business Tax Filing</li>
                <li className="mb-3"><i className="bi bi-flag-fill text-warning me-2"></i>IRS & State Notice/Audit Resolution</li>
                <li className="mb-3"><i className="bi bi-graph-up-arrow text-violet me-2"></i>Tax & Business Consulting</li>
                <li className="mb-3"><i className="bi bi-journal-bookmark text-info me-2"></i>Bookkeeping & Payroll Services</li>
              </ul>
            </div>
          </div>
        </div>
      </section> */}

      {/* WHY CHOOSE US SECTION */}
      <section className="py-5 bg-white" data-aos="fade-up">
        <div className="container px-0 px-md-2">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-11">
              <div className="p-4 p-md-5 rounded-4 shadow-sm" style={{ background: "#faf6ff" }}>
                <h2
                  className="fw-bold mb-4"
                  style={{
                    background: "linear-gradient(90deg,#6B46C1,#D53F8C)",
                    color: "transparent",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    fontFamily: "'Poppins',sans-serif"
                  }}
                >
                  Why Choose Nexen?
                </h2>
                <div className="row g-4">
                  <div className="col-md-6 d-flex align-items-start">
                    <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light me-3 icon-42">
                      <i className="bi bi-stars fs-4 text-primary"></i>
                    </span>
                    <div>
                      <div className="fw-semibold mb-1" style={{ color: "#6B46C1" }}>Proven Expertise</div>
                      <div className="text-secondary">
                        Our seasoned consultants combine years of tax, IT, and business experience—so you get credible, accurate guidance.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 d-flex align-items-start">
                    <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light me-3 icon-42">
                      <i className="bi bi-person-heart fs-4 text-pink" style={{ color: "#D53F8C" }}></i>
                    </span>
                    <div>
                      <div className="fw-semibold mb-1" style={{ color: "#D53F8C" }}>Personalized Partnerships</div>
                      <div className="text-secondary">
                        We truly get to know your goals, challenges, and dreams—offering tailored solutions, not cookie-cutter advice.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 d-flex align-items-start">
                    <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light me-3 icon-42">
                      <i className="bi bi-shield-check fs-4 text-success"></i>
                    </span>
                    <div>
                      <div className="fw-semibold mb-1" style={{ color: "#31926A" }}>Security & Integrity</div>
                      <div className="text-secondary">
                        Transparent, ethical, and confidential—trust us to safeguard your data and financial well-being at all times.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 d-flex align-items-start">
                    <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light me-3 icon-42">
                      <i className="bi bi-lightning-charge-fill fs-4 text-warning"></i>
                    </span>
                    <div>
                      <div className="fw-semibold mb-1" style={{ color: "#F3B211" }}>Efficiency & Responsiveness</div>
                      <div className="text-secondary">
                        Fast answers and proactive support—so deadlines are never missed and problems are solved before they grow.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <span className="fw-semibold fs-5" style={{ color: "#6B46C1" }}>
                    Choose Nexen—where strategy meets service, and your success comes first.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Gradient text style for headings */}
        <style>{`
    .text-pink { color: #D53F8C }
  `}</style>
      </section>


      <section className="py-4 bg-light border-top border-bottom">
        <div className="container">
          <div className="row g-4 justify-content-center text-center">
            {[
              { icon: "bi bi-magic", label: "Fast Online Filing", color: "#6B46C1" },
              { icon: "bi bi-person-check", label: "Secure & Private", color: "#31926A" },
              { icon: "bi bi-shield-lock", label: "IRS Authorized", color: "#224eae" },
              { icon: "bi bi-journal-medical", label: "Dedicated Professionals", color: "#D53F8C" },
              { icon: "bi bi-phone", label: "24/7 Support", color: "#D53F8C" }
                ].map(({ icon, label, color }, i) => (
              <div className="col-6 col-sm-4 col-md-2" key={i} data-aos="fade-up" data-aos-delay={i * 70}>
                <span className="d-inline-flex align-items-center justify-content-center rounded-circle mb-2 icon-46" style={{
                  background: "#fff", boxShadow: "0 2px 8px #d53f8c17"
                }}>
                  <i className={`${icon} fs-3`} style={{ color }}></i>
                </span>
                <div className="fw-semibold" style={{ color, fontSize: "1rem" }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </section >

      {/* TESTIMONIALS/REVIEWS CAROUSEL */}
      < section className="py-5 bg-white border-bottom" >
        <div className="container">
          <h3 className="fw-bold text-center mb-5" style={{
            color: "#344476", 
            fontFamily: "'Poppins',sans-serif",
            fontSize: "2.5rem"
          }}>
            What Our Clients Say
          </h3>
          
          <Slider
            dots={true}
            infinite={true}
            speed={800}
            slidesToShow={3}
            slidesToScroll={1}
            autoplay={true}
            autoplaySpeed={4000}
            pauseOnHover={true}
            cssEase="ease-in-out"
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                }
              }
            ]}
          >
            {[
              { quote: "The Nexen team got us the biggest refund ever, fast and so easy. Highly recommended!", name: "Emily R." },
              { quote: "I’m based in the US, and Nexen Consulting helped me file both my US and Indian taxes. Smooth process, clear communication, and reliable service. Highly recommended for NRIs!", name: "Abhinav" },
              { quote: "Their business consulting drove real results. Tech-savvy, honest and always available.", name: "John T." },
              { quote: "I didn't even know what FATCA meant—Nexen did everything so I could sleep at night.", name: "Priya P." },
              { quote: "As an NRI, tax filing was always complicated for me. Nexen made it seamless and saved me thousands in refunds. Truly professional service!", name: "Rajesh Kumar" },
              { quote: "Outstanding support for my ITIN application. The team was patient, knowledgeable, and guided me through every step. Thank you Nexen!", name: "Anjali Sharma" },
              { quote: "Nexen helped me resolve my IRS notice quickly and efficiently. Their expertise in tax matters is unmatched. Highly recommend their services!", name: "Vikram Patel" },
              { quote: "The business consulting services transformed our operations. Nexen's strategic approach helped us scale our business effectively. Excellent work!", name: "Meera Reddy" },
              { quote: "Great service! I stay in the US and Nexen handled both my US and Indian tax filings easily and professionally.", name: "Neha Sharma" },
              { quote: "Professional, reliable, and always available. Nexen handled my FBAR filing perfectly and ensured full compliance. Peace of mind guaranteed!", name: "Arjun Singh" },
            ].map((rev, i) => (
              <div key={i} className="px-3">
                <div className="card shadow-lg border-0 p-4 text-center h-100 rounded-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  minHeight: "200px"
                }}>
                  <div className="mb-3">
                    <i className="bi bi-quote fs-1" style={{ color: "#6B46C1", opacity: 0.3 }}></i>
                  </div>
                  <p className="fst-italic mb-3 text-secondary" style={{ fontSize: "1rem", lineHeight: "1.6" }}>
                    "{rev.quote}"
                  </p>
                  <div className="fw-bold" style={{
                    background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                    backgroundClip: "text",
                    fontSize: "1.1rem"
                  }}>
                    {rev.name}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          
          <style>{`
            .slick-dots li button:before {
              color: #6B46C1 !important;
              font-size: 12px;
            }
            .slick-dots li.slick-active button:before {
              color: #D53F8C !important;
            }
            .slick-prev:before,
            .slick-next:before {
              color: #6B46C1 !important;
              font-size: 30px;
            }
            .slick-prev {
              left: -40px;
            }
            .slick-next {
              right: -40px;
            }
            @media (max-width: 768px) {
              .slick-prev {
                left: -20px;
              }
              .slick-next {
                right: -20px;
              }
            }
          `}</style>
        </div>
      </section >
    </div>
  );
}
